import { jsx, jsxs } from 'react/jsx-runtime';
import { Colors } from '../../../../theme/Colors.es.js';
import { CTATextContent } from '../CTATextContent.es.js';
import { getBgColor } from '../utils.es.js';
import { LegacyColorMap } from '../../../../theme/LegacyColorMap.es.js';

const root = "_root_fm5d4_1";
const content = "_content_fm5d4_17";
const mediaContent = "_media-content_fm5d4_33";
const styles = {
	root: root,
	content: content,
	mediaContent: mediaContent
};

const CTAStandard = ({ backgroundColor = "white", heading, subHeading, ctaText, ctaHref, ctaBtnColor, description, onCtaClick, onCtaKeyDown, children, maxWidth = 1170, ctaTarget }) => {
  const bgColor = getBgColor(backgroundColor);
  return jsx("div", { className: styles.root, style: {
    "--_zds-cta-standard-bg-color": Colors[LegacyColorMap[bgColor]]
  }, "data-zds": true, children: jsxs("div", { className: styles.content, style: {
    "--_zds-cta-standard-max-width": `${maxWidth}px`
  }, "data-zds": true, children: [jsx(CTATextContent, { heading, subHeading, description, ctaText, ctaHref, ctaBtnColor, onCtaClick, onCtaKeyDown, bgColor, ctaTarget }), jsx("div", { className: styles.mediaContent, "data-testid": "media-content", "data-zds": true, children })] }) });
};

export { CTAStandard };
//# sourceMappingURL=CTAStandard.es.js.map
